import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getMarket } from "./createI18n";
import type { Locale } from "./locale";

const INTL_TAGS: Record<Locale, string> = { fi: "fi-FI", en: "en-GB" };

export function useFormatters() {
  const { i18n } = useTranslation();
  const tag = getMarket(i18n) === "us" ? "en-US" : (INTL_TAGS[i18n.language as Locale] ?? INTL_TAGS.fi);

  return useMemo(() => {
    const date = new Intl.DateTimeFormat(tag, { day: "numeric", month: "numeric", year: "numeric" });
    const dateTime = new Intl.DateTimeFormat(tag, { dateStyle: "short", timeStyle: "short" });
    const time = new Intl.DateTimeFormat(tag, { timeStyle: "short" });
    const currencyEur = new Intl.NumberFormat(tag, { style: "currency", currency: "EUR" });
    const collator = new Intl.Collator(tag);
    return { tag, date, dateTime, time, currencyEur, compare: collator.compare.bind(collator) };
  }, [tag]);
}
